import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronBoldLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M10.805 18.756 25.047 4.515a1.759 1.759 0 0 1 2.487 0l1.661 1.661c.686.686.687 1.797.003 2.484L17.91 20l11.286 11.34a1.758 1.758 0 0 1-.003 2.484l-1.661 1.661c-.687.687-1.8.687-2.487 0L10.805 21.243a1.759 1.759 0 0 1 0-2.487Z" })
});
export default SvgChevronBoldLeft;
